<template>

  <div class="filters">
    <div>
      <assets-tree v-model="filters.assetIds" :shv-disabled="true" :select-self="true" @assets="assets = $event"></assets-tree>
    </div>

    <div>
      <variables-tree v-model="filters.variableIds" :assets="assets" :autoselect="true" @variables="$emit('variables', $event)"></variables-tree>
    </div>

    <div>
      <date-range-picker v-model="filters.time"></date-range-picker>
    </div>
  </div>

</template>

<script>
  import AssetsTree from '../assets/components/assets-tree'
  import VariablesTree from '../assets/components/variables-tree'
  import DateRangePicker from '../shared/components/date-range-picker'

  export default {
    name: 'log-filters',

    props: [ 'filters' ],

    data () {
      return {
        assets: []
      }
    },

    watch: {
      filters: {
        deep: true,
        handler () {
          this.$emit('change', this.filters)
        }
      }
    },

    components: {
      DateRangePicker,
      VariablesTree,
      AssetsTree
    }
  }
</script>

<style scoped lang="scss">

</style>
